import { render, staticRenderFns } from "./ConfigurazioneGeneraleVociMenuModalEditComponent.vue?vue&type=template&id=b4542e3c"
import script from "./ConfigurazioneGeneraleVociMenuModalEditComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneGeneraleVociMenuModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports